export const ACTIONS = {
  EDIT: 'EDIT'
}

export const SUBJECTS = {
  VENDOR_DETAILS: 'VENDOR_DETAILS'
}
